import {
    CustomerState,
    CustomerActionTypes,
    GET_CUSTOMER_NUMBERS,
    GET_CUSTOMER_NUMBERS_SUCCESS,
    GET_CUSTOMER_NUMBERS_ERROR,
    SET_ACTIVE_CUSTOMER_NUMBER,
    SHOW_NUMBER_SELECTION_DIALOG,
    HIDE_NUMBER_SELECTION_DIALOG,
    GET_CUSTOMER_FEATURES,
    GET_CUSTOMER_FEATURES_SUCCESS,
    GET_CUSTOMER_FEATURES_ERROR,
    SET_CUSTOMER_NAME,
} from './types';

const initialState: CustomerState = {
    fetchingCustomerNumbers: false,
    customerNumbers: [],
    customerNumbersError: null,
    activeCustomerNumber: null,
    numberSelectionDialogVisible: false,
    fetchingFeatures: false,
    features: null,
    featuresError: null,
    customerName: '',
};

export default function customerReducer(
    state: CustomerState = initialState,
    action: CustomerActionTypes,
): CustomerState {
    switch (action.type) {
        case GET_CUSTOMER_NUMBERS:
            return { ...state, fetchingCustomerNumbers: true };
        case GET_CUSTOMER_NUMBERS_SUCCESS:
            return {
                ...state,
                fetchingCustomerNumbers: false,
                customerNumbers: action.payload.customerNumbers,
                customerNumbersError: null,
            };
        case GET_CUSTOMER_NUMBERS_ERROR:
            return {
                ...state,
                fetchingCustomerNumbers: false,
                customerNumbers: [],
                customerNumbersError: action.payload.error,
            };
        case SET_ACTIVE_CUSTOMER_NUMBER:
            return {
                ...state,
                activeCustomerNumber: action.payload.customerNumber,
            };
        case SHOW_NUMBER_SELECTION_DIALOG:
            return {
                ...state,
                numberSelectionDialogVisible: true,
            };
        case HIDE_NUMBER_SELECTION_DIALOG:
            return {
                ...state,
                numberSelectionDialogVisible: false,
            };
        case GET_CUSTOMER_FEATURES:
            return {
                ...state,
                fetchingFeatures: true,
            };
        case GET_CUSTOMER_FEATURES_SUCCESS:
            return {
                ...state,
                fetchingFeatures: false,
                features: action.payload.features,
            };
        case GET_CUSTOMER_FEATURES_ERROR:
            return {
                ...state,
                fetchingFeatures: false,
                featuresError: action.payload.error,
            };
        case SET_CUSTOMER_NAME:
            return {
                ...state,
                customerName: action.payload.customerName,
            };
        default:
            return { ...state };
    }
}
